export { default as Trim } from './page'


// WEBPACK FOOTER //
// ./src/pages/Trim/index.js